module.exports = __webpack_public_path__ + "assets/img/bannoubiz.20aa471a.svg";